import React, { useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import InputCst from "@components/InputCst/InputCst";
import LtiAccountPickerCst from "@components/LtiAccountPickerCst";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../../types";
import AssociationFieldPlaceholder from "../AssociationFieldPlaceholder";

const LtiContent: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
  errors,
}) => {
  const { t } = useTranslation("wizard-activity");
  const { t: tPicker } = useTranslation("lti-account-picker");

  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <InputCst
        id="activity-lti-external-id"
        label={`${t("content.lti.external-id")} *`}
        value={data.external_id}
        onChange={(e: any) => setData({ external_id: e.target.value })}
        error={!!errors.external_id}
        errorMessage={
          errors.external_id ? t(`errors.${errors.external_id}`) || "" : ""
        }
      />
      <AssociationFieldPlaceholder
        label={t("content.lti.account")}
        required
        value={data.lti_account_id}
        onChange={(next) => setData({ lti_account_id: next })}
        addLabel={t("common.add") || "Aggiungi"}
        emptyLabel={t("common.empty") || "Nessun elemento aggiunto"}
        error={!!errors.lti_account_id}
        errorMessage={
          errors.lti_account_id
            ? t(`errors.${errors.lti_account_id}`) || ""
            : ""
        }
        onAddClick={() => setPickerOpen(true)}
      />

      <LtiAccountPickerCst
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        title={tPicker("title") || "Aggiungi Account LTI"}
        initialSelection={
          data.lti_account_id
            ? {
                id: Number(data.lti_account_id.id),
                label: data.lti_account_id.label || "",
              }
            : null
        }
        onConfirm={(selection) => setData({ lti_account_id: selection })}
      />
    </Box>
  );
};

export default LtiContent;
